module.exports = __webpack_public_path__ + "img/89.238a31f6.svg";